import { cn } from '@/lib/utils';

const markSizes = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-14 w-14',
};

export function BrandMark({ size = 'md', className }) {
  return (
    <div
      className={cn(
        'relative rounded-2xl border border-white/15 bg-[#0b1430] p-0.5 shadow-lg shadow-black/20',
        markSizes[size] || markSizes.md,
        className
      )}
      aria-hidden="true"
    >
      <svg viewBox="0 0 64 64" className="h-full w-full rounded-[14px]">
        <defs>
          <linearGradient id="dinespot-bg" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#111f49" />
            <stop offset="100%" stopColor="#0a1128" />
          </linearGradient>
          <linearGradient id="dinespot-gold" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#fde68a" />
            <stop offset="100%" stopColor="#f59e0b" />
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="64" height="64" rx="14" fill="url(#dinespot-bg)" />
        <path
          d="M32 14c-7.3 0-13.2 5.8-13.2 13 0 8.9 11.2 19.9 12.1 20.9a1.6 1.6 0 0 0 2.2 0c0.9-1 12.1-12 12.1-20.9C45.2 19.8 39.3 14 32 14Z"
          fill="none"
          stroke="url(#dinespot-gold)"
          strokeWidth="2.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="32" cy="27" r="6" fill="none" stroke="url(#dinespot-gold)" strokeWidth="2.3" />
        <circle cx="32" cy="27" r="1.8" fill="url(#dinespot-gold)" />
        <path d="M42.5 15.5l1.5 1.5m0-1.5-1.5 1.5" stroke="#fde68a" strokeWidth="1.7" strokeLinecap="round" />
      </svg>
    </div>
  );
}

export default function BrandLogo({ size = 'md', className, textClassName }) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <BrandMark size={size} />
      <span className={cn('font-heading text-xl font-bold tracking-tight text-slate-900', textClassName)}>DineSpot</span>
    </div>
  );
}
